import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67bd692e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nv-date-field-calendar__header" }
const _hoisted_2 = { class: "header__month" }
const _hoisted_3 = ["onClick", "onMouseover"]
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nv-date-field-calendar", {
            'nv-date-field-calendar--disabled': _ctx.disabled
        }]),
    ref: "calendarEl"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.viewMonthName) + " ", 1),
        (_ctx.yearShowed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.viewYear), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "nv-date-field-calendar__content",
      onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideAllTooltips && _ctx.hideAllTooltips(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.view_state.dates, (date, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["content__date", {
                    'date--disabled': _ctx.isDateDisabled(date),
                    'date--from-previous-month-or-year': _ctx.isDateFromPreviousMonthOrYear(date),
                    'date--from-next-month-or-year': _ctx.isDateFromNextMonthOrYear(date),
                    'date--in-period': _ctx.isDateInPeriod(date),
                    'date--first-in-period': _ctx.isDateFirstInPeriod(date),
                    'date--last-in-period': _ctx.isDateLastInPeriod(date),
                    'date--in-reserved-period': _ctx.isDateInReservedPeriod(date),
                    'date--first-in-reserved-period': _ctx.isDateFirstInReservedPeriod(date),
                    'date--last-in-reserved-period': _ctx.isDateLastInReservedPeriod(date),
                }]),
          key: i,
          onClick: ($event: any) => (_ctx.onDateClick(date)),
          onMouseover: (e) => _ctx.onDateMouseover(e, date)
        }, _toDisplayString(date.getDate()), 43, _hoisted_3))
      }), 128))
    ], 32),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reservedPeriods, (reservedPeriod) => {
      return (_openBlock(), _createElementBlock("div", {
        key: reservedPeriod.id,
        id: `nv-calendar-tooltip-${_ctx.calendarId}-${reservedPeriod.id}`,
        class: "nv-date-field-calendar__tooltip"
      }, _toDisplayString(reservedPeriod.name), 9, _hoisted_4))
    }), 128))
  ], 2))
}